import React from "react";
import {
  Icon,
  Flex,
  Input,
  InputGroup,
  FormControl,
  InputLeftElement
} from "@chakra-ui/react";
import { useSearch } from "../../../hooks/useSearch";
import { BsSearch } from "react-icons/bs";

export function SearchProperty({
  initialInputState,
  onChange
}: {
  initialInputState?: string;
  onChange?: (value: string) => void;
}) {
  const search = useSearch({ initialValue: initialInputState, onChange });

  return (
    <FormControl marginBottom="1rem" marginTop="1rem">
      <Flex>
        <InputGroup size="sm" width="100%" border={'none'} outline='none'>
          <InputLeftElement children={<Icon as={BsSearch} fill="#2e384d" />} />
          <Input
            type="text"
            color="#212242"
            placeholder="Search"
            focusBorderColor='none'
            borderColor={'#eee'}
            borderRadius='md'
            value={search.value}
            onChange={search.handleValueChange}
          />
        </InputGroup>
      </Flex>
    </FormControl>
  );
}
